export default new Vuex.Store(store)
